import React from 'react';

import style from './index.module.scss';

import clsx from 'clsx';
import {
  UserBoxClinicalMeeting,
  UserBoxProgramDuration,
  UserBoxSupportMeeting,
} from '../../../user-info-boxes';
import { Stack } from 'components/stack';
import { GridMeetings } from '../../grids';
import { TilesSummary } from 'components/tiles-summary';

interface Props {
  className?: string;
  userPatientProfileID: string;
}

export const TabAppointments: React.FC<React.PropsWithChildren<Props>> = ({
  userPatientProfileID,
  className,
}) => {
  return (
    <div className={clsx(style.root, className)}>
      {/* N2 (T3, DC-21): below md the tiles collapse into one summary line */}
      <TilesSummary>
        <Stack spacing={1} className={style.boxes}>
          <UserBoxProgramDuration userPatientProfileID={userPatientProfileID} />
          <UserBoxSupportMeeting userPatientProfileID={userPatientProfileID} order={'last'} />
          <UserBoxSupportMeeting userPatientProfileID={userPatientProfileID} order={'next'} />
          <UserBoxClinicalMeeting userPatientProfileID={userPatientProfileID} order={'last'} />
          <UserBoxClinicalMeeting userPatientProfileID={userPatientProfileID} order={'next'} />
        </Stack>
      </TilesSummary>
      <GridMeetings userPatientProfileID={userPatientProfileID} />
    </div>
  );
};
